<template>
  <div>
    <el-upload
      :http-request="chunkedUpload"
      :ref="chunkedUpload"
      :action="uploadUrl"
      :data="uploadData"
      :on-error="onError"
      :before-remove="beforeRemove"
      :on-progress="progress"
      name="file"
      multiple
      :limit="3"
      >上传</el-upload
    >
  </div>
</template>

<script>
import chunkedUpload from "./chunkedUpload";
export default {
  data() {
    return {
      uploadData: {
        //这里面放额外携带的参数
      },
      //文件上传的路径
      uploadUrl: "http://192.168.0.132:44314", //文件上传的路径
      chunkedUpload: chunkedUpload, // 分片上传自定义方法，在头部引入了
    };
  },
  methods: {
    progress(e) {
      // console.log(e);
    },
    onError(err, file, fileList) {
      // this.$store.getters.chunkedUploadXhr.forEach((item) => {
      //   item.abort();
      // });
      this.$alert("文件上传失败，请重试", "错误", {
        confirmButtonText: "确定",
      });
    },
    beforeRemove(file) {
      // 如果正在分片上传，则取消分片上传
      if (file.percentage !== 100) {
        // this.$store.getters.chunkedUploadXhr.forEach((item) => {
        //   item.abort();
        // });
      }
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/page/b.vue